import { render, staticRenderFns } from "./OptionsSyncContainer.vue?vue&type=template&id=56e78457&scoped=true&"
import script from "./OptionsSyncContainer.vue?vue&type=script&lang=js&"
export * from "./OptionsSyncContainer.vue?vue&type=script&lang=js&"
import style0 from "./OptionsSyncContainer.vue?vue&type=style&index=0&id=56e78457&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56e78457",
  null
  
)

export default component.exports